// web端详情展开菜单方法
$(document).on('click','.h-click-description-module-box-top',function(){
	// 获取当前点击的为哪一个
	let clickBoxType = $(this).attr('value');
	// console.log('******', clickBoxType);
  // 当没有展开时，添加class并展开
  if(!$(this).hasClass('module-box-active')){
    $(this).parents('.h-description-module-box').children('.h-description-module-box-con').children('.h-description-con-div').children('.h-description-con-div-other').slideDown();  // 展开这个菜单
    $(this).children('.h-description-con-div-img').find('.open_icon').attr('src', 'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon_ic_back_light_r_2x_1_add89403-e344-4fc3-8638-1678eb6a4f26.png?v=1634906272'); // 更换图片
		$(this).addClass('module-box-active');
		// 当展开时进行数据上报
		if ( clickBoxType == 'productDetail' ) {
			// 点击和打开上报
			detail_click_product_details();
			detail_open_product_details();
		} else if ( clickBoxType == 'materialCare' ) {
      // 点击和打开上报
			detail_click_material_care();
			detail_open_material_care();
		}
  } else {
    $(this).parents('.h-description-module-box').children('.h-description-module-box-con').children('.h-description-con-div').children('.h-description-con-div-other').slideUp();    // 收起这个菜单
    $(this).children('.h-description-con-div-img').find('.open_icon').attr('src', 'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon_ic_back_light_r_2x_17e7473c-4f7c-40ca-a4cf-6cb4a64d3ff7.png?v=1634906272'); // 更换图片
    $(this).removeClass('module-box-active');
  }
});

// SIZE GUIDE表格切换
$(document).on('click','.size-right-tab li',function(){
	let sizeTabIndex = $(this).index();
	// tab样式切换
	$(this).parents('.size-right-tab').children('li').removeClass('active');
	$(this).addClass('active');
	// table内容切换
	$(this).parents('.model-size-guide-product-size-box').find('.size-ul-table').children('li').removeClass('tablebox-current');
	$(this).parents('.model-size-guide-product-size-box').find('.size-ul-table').children('li:eq(' + sizeTabIndex + ')').addClass('tablebox-current');
});

// Measurements切换
$(document).on('click','.h-measurements-tabbox li',function(){
	let measurementsTabIndex = $(this).index();
	// tab样式切换
	$(this).parents('.h-measurements-tabbox').children('li').removeClass('active');
	$(this).addClass('active');
	// table内容切换
	$(this).parents('.model-size-guide-measurements-box').find('.h-measurements-tabbox-content').children('li').removeClass('tabbox-current');
	$(this).parents('.model-size-guide-measurements-box').find('.h-measurements-tabbox-content').children('li:eq(' + measurementsTabIndex + ')').addClass('tabbox-current');
});

// -----------html片段参数定义-------------
// 生成size规格信息模块
var getProductSizeTableModel = `
	<% if ( data.productDetailSizeTablePropertyList && data.bodySizeList ) { %>
		<% for ( var item of (data.bodySizeList.length > 0 ? data.bodySizeList : data.productDetailSizeTablePropertyList) ) { %>
			<div class="h-size-describe-commodity-data-con" value="<%= item.internationalCode %>">
				<% if ( data.bodySizeList.length > 0 ) { %>
					<div class="h-con-body-size">Body Size</div>
				<% } %>
				<div class="h-con-list <% if ( data.bodySizeList.length > 0 ) { %>h-con-list-padding<% } %>">
					<% for ( var item2 of item.sizeTablePropertyList ) { %>
						<div class="h-data-li"><%= item2.propertyName %>: 
							<span>
								<% if ( item2.propertyValue.indexOf("-") == -1 ) { %>
									<%= Math.round(item2.propertyValue*0.3937*10)/10 %>
								<% } else { %>
									<% for ( let [ index3, item3 ] of new Map( item2.propertyValue.split("-").map( ( item, index ) => [ index, item ] ) ) ) { %>
										<%= Math.round(item3*0.3937*10)/10 %><% if ( index3+1 < item2.propertyValue.split("-").length ) { %> -<% } %>
									<% } %>
								<% } %>
								in
							</span>
						</div>
					<% } %>
				</div>
			</div>
		<% } %>
	<% } %>
`;

// 添加product detail以及material care模块
var getProductContentModel = `
	<!-- 手机端 -->
	<div class="h-description-module-box-phone">
		<% if ( data.productDetail && ( data.productDetail.propertyList || data.sellingPoints ) ) { %>
			<div class="h-description-module-box h-description-productsize-click">
				<!-- 标题区域 -->
				<% if ( data.productDetail.propertyGroupName ) { %>
					<div class="h-description-module-box-top">
						<p class="h-module-box-title"><%= data.productDetail.propertyGroupName %></p>
						<div class="h-module-box-right">
							<img src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon-right-img.png?v=1645427665" />
						</div>
					</div>
				<% } %>
				<!-- 内容区域 -->
				<% if ( data.productDetail.propertyList && data.productDetail.propertyList.length > 0 ) { %>
					<div class="h-description-module-box-con">
						<% if ( data.sellingPoints ) { %>
							<div class="h-description-con-text"><%= data.sellingPoints %></div>
						<% } %>
						<% if (data.productDetail.propertyList.length > 0  ) { %>
							<div class="h-description-con-div">
								<% for ( var item of data.productDetail.propertyList ) { %>
									<% if ( item.defaultShowStatus == 1 && item.propertyValueList.length > 0 ) { %>
										<div class="tag-div">
											<% for ( let [ index2, item2 ] of new Map( item.propertyValueList.map( ( item, index ) => [ index, item ] ) ) ) { %>
												<%= item2 %><% if ( index2+1 < item.propertyValueList.length ) { %>、<% } %>
											<% } %>
										</div>
									<% } %>
								<% } %>
							</div>
						<% } %>
					</div>
				<% } %>
			</div>
		<% } %>
		<% if ( data.materialCare ) { %>
			<div class="h-description-module-box h-description-materialcare-click">
				<!-- 标题区域 -->
				<% if ( data.materialCare.propertyGroupName ) { %>
					<div class="h-description-module-box-top">
						<p class="h-module-box-title"><%= data.materialCare.propertyGroupName %></p>
						<div class="h-module-box-right">
							<img src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon-right-img.png?v=1645427665" />
						</div>
					</div>
				<% } %>
				<!-- 内容区域 -->
				<% if ( data.materialCare.propertyList.length > 0 ) { %>
					<div class="h-description-module-box-con">
						<div class="h-description-con-div">
							<% for ( var item of data.materialCare.propertyList ) { %>
								<% if ( item.defaultShowStatus == 1  && item.propertyValueList.length > 0 ) { %>
									<div class="tag-div">
										<% for ( let [ index2, item2 ] of new Map( item.propertyValueList.map( ( item, index ) => [ index, item ] ) ) ) { %>
											<%= item2 %><% if ( index2+1 < item.propertyValueList.length ) { %>、<% } %>
										<% } %>
									</div>
								<% } %>
							<% } %>
						</div>
					</div>
				<% } %>
			</div>
		<% } %>
	</div>
	<!-- web端 -->
	<div class="h-description-module-box-web">
		<% if ( data.productDetail && data.productDetail.propertyList ) { %>
			<div class="h-description-module-box">
				<!-- 标题区域 -->
				<% if ( data.productDetail.propertyGroupName ) { %>
					<div class="h-description-module-box-top h-click-description-module-box-top" value="productDetail">
						<p class="h-module-box-title"><%= data.productDetail.propertyGroupName %></p>
						<% if ( data.productDetail.propertyList && data.productDetail.propertyList.filter(item => item.defaultShowStatus == 2).length > 0 ) { %>
							<div class="h-description-con-div-img">
								<img class="open_icon" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon_ic_back_light_r_2x_17e7473c-4f7c-40ca-a4cf-6cb4a64d3ff7.png?v=1634906272" />
							</div>
						<% } %>
					</div>
				<% } %>
				<!-- 内容区域 -->
				<% if ( data.productDetail.propertyList && data.productDetail.propertyList.length > 0 ) { %>
					<div class="h-description-module-box-con">
						<% if ( data.sellingPoints ) { %>
							<div class="h-description-con-text"><%= data.sellingPoints %></div>
						<% } %>
						<div class="h-description-con-div">
							<% for ( var item of data.productDetail.propertyList ) { %>
								<% if ( item.defaultShowStatus == 1 && item.propertyValueList.length > 0 ) { %>
									<div class="h-description-con-div-li">
										<p class="li-left"><%= item.propertyName %></p>
										<p class="li-right">
											<% for ( let [ index2, item2 ] of new Map( item.propertyValueList.map( ( item, index ) => [ index, item ] ) ) ) { %>
												<%= item2 %><% if ( index2+1 < item.propertyValueList.length ) { %>、<% } %>
											<% } %>
										</p>
									</div>
								<% } %>
							<% } %>
							<div class="h-description-con-div-other <% if ( (data.productDetail.propertyList && data.productDetail.propertyList.filter(item => item.defaultShowStatus == 1).length)%2 != 0 ) { %>set-div-color<% } %>">
								<% for ( var item of data.productDetail.propertyList ) { %>
									<% if ( item.defaultShowStatus == 2 && item.propertyValueList.length > 0 ) { %>
										<div class="h-description-con-div-li">
											<p class="li-left"><%= item.propertyName %></p>
											<p class="li-right">
												<% for ( let [ index2, item2 ] of new Map( item.propertyValueList.map( ( item, index ) => [ index, item ] ) ) ) { %>
													<%= item2 %><% if ( index2+1 < item.propertyValueList.length ) { %>、<% } %>
												<% } %>
											</p>
										</div>
									<% } %>
								<% } %>
							</div>
						</div>
					</div>
				<% } %>
			</div>
		<% } %>
		<% if ( data.materialCare ) { %>
			<div class="h-description-module-box">
				<!-- 标题区域 -->
				<% if ( data.materialCare.propertyGroupName ) { %>
					<div class="h-description-module-box-top h-click-description-module-box-top" value="materialCare">
						<p class="h-module-box-title"><%= data.materialCare.propertyGroupName %></p>
						<div class="h-description-con-div-img">
							<img class="open_icon" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon_ic_back_light_r_2x_17e7473c-4f7c-40ca-a4cf-6cb4a64d3ff7.png?v=1634906272" />
						</div>
					</div>
				<% } %>
				<!-- 内容区域 -->
				<% if ( data.materialCare.propertyList.length > 0 ) { %>
					<div class="h-description-module-box-con">
						<div class="h-description-con-div">
							<% for ( var item of data.materialCare.propertyList ) { %>
								<% if ( item.defaultShowStatus == 1 && item.propertyValueList.length > 0 ) { %>
									<div class="h-description-con-div-li">
										<p class="li-left"><%= item.propertyName %></p>
										<p class="li-right">
											<% for ( let [ index2, item2 ] of new Map( item.propertyValueList.map( ( item, index ) => [ index, item ] ) ) ) { %>
												<% if (item2.indexOf("100%") != -1 && item.propertyName == "Composition") { %>
													<%= item2.replace("100%", "") %>
												<% } else { %>
													<%= item2 %>
												<% } %>
												<% if ( index2+1 < item.propertyValueList.length ) { %>、<% } %>
											<% } %>
										</p>
									</div>
								<% } %>
							<% } %>
							<div class="h-description-con-div-other h-description-con-div-other-care-introduction">
								<div class="con-model-care-introduction">
									<div class="model-care-intro-li">
										<img src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon_care1.png?v=1645067028" />
										<p class="intro-li-text">Machine wash max. 30°C/86°F delicate cycle</p>
									</div>
									<div class="model-care-intro-li">
										<img src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon_care2.png?v=1645067027" />
										<p class="intro-li-text">Do not use bleach / whitener</p>
									</div>
									<div class="model-care-intro-li">
										<img src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon_care3.png?v=1645067028" />
										<p class="intro-li-text">Iron maximum 110°C/230°F</p>
									</div>
									<div class="model-care-intro-li">
										<img src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon_care4.png?v=1645067028" />
										<p class="intro-li-text">Iron maximum 110°C/230°F</p>
									</div>
									<div class="model-care-intro-li">
										<img src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon_care5.png?v=1645067027" />
										<p class="intro-li-text">Do not tumble dry</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				<% } %>
			</div>
		<% } %>
	</div>
`;

// 创建product size弹窗html
var productSizeContent = `
	<div class="looksky-main-popup-con" style="max-height: 60%;">
		<!-- 标题区域 -->
		<div class="main-popup-con-title"><% if ( data.productDetail && data.productDetail.propertyGroupName ) { %><%= data.productDetail.propertyGroupName %><% } %>
			<div class="title-close">
				<img src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/looksky_popup_close.png?v=1645788039" />
			</div>
		</div>
		<!-- Product Details内容区域 -->
		<div class="main-popup-con-model">
			<% if ( data.sellingPoints ) { %>
				<div class="main-popup-con-model-texttip"><%= data.sellingPoints %></div>
			<% } %>
			<% for ( var item of data.productDetail.propertyList ) { %>
				<% if ( item.propertyValueList.length > 0 ) { %>
					<div class="main-popup-con-model-li">
						<p class="li-left"><%= item.propertyName %></p>
						<p class="li-right">
							<% for ( let [ index2, item2 ] of new Map( item.propertyValueList.map( ( item, index ) => [ index, item ] ) ) ) { %>
								<%= item2 %><% if ( index2+1 < item.propertyValueList.length ) { %>、<% } %>
							<% } %>
						</p>
					</div>
				<% } %>
			<% } %>
		</div>
	</div>
`;

// 创建materialCare弹窗html
var materialCareContent = `
	<div class="looksky-main-popup-con" style="max-height: 60%;">
		<!-- 标题区域 -->
		<div class="main-popup-con-title"><% if ( data.materialCare && data.materialCare.propertyGroupName ) { %><%= data.materialCare.propertyGroupName %><% } %>
			<div class="title-close">
				<img src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/looksky_popup_close.png?v=1645788039" />
			</div>
		</div>
		<!-- Material & Care内容区域 -->
		<div class="main-popup-con-model">
			<% for ( var item of data.materialCare.propertyList ) { %>
				<% if ( item.propertyValueList.length > 0 ) { %>
					<div class="main-popup-con-model-li">
						<p class="li-left"><%= item.propertyName %></p>
						<p class="li-right">
							<% for ( let [ index2, item2 ] of new Map( item.propertyValueList.map( ( item, index ) => [ index, item ] ) ) ) { %>
								<%= item2 %>
								<% if ( index2+1 < item.propertyValueList.length ) { %>、<% } %>
							<% } %>
						</p>
					</div>
				<% } %>
			<% } %>
			<div class="main-popup-con-model-care">
				<div class="con-model-care-introduction">
					<% for ( var item of data.careList ) { %>
						<div class="model-care-intro-li">
							<img src="<%= item.imgurl %>" />
							<p class="intro-li-text"><%= item.text %></p>
						</div>
					<% } %>
				</div>
			</div>
		</div>
	</div>
`;

// 创建size guide弹窗html
var sizeGuideContent = `
	<div class="looksky-main-popup-con" style="max-height: 90%;">
		<!-- 标题区域 -->
		<div class="main-popup-con-title">SIZE GUIDE
			<div class="title-close">
				<img src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/looksky_popup_close.png?v=1645788039" />
			</div>
		</div>
		<!-- SIZE GUIDE内容区域 -->
		<div class="main-popup-con-model">
			<div class="con-model-size-guide">
				<img class="loading-img" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/bodysize_loading.png?v=1647916707" />
			</div>
		</div>
	</div>
`;

// 详情页size guide弹窗数据内容模块
var sizeGuideContentData = `
	<!-- 步骤条区域 -->
	<% if ( data.propertyGroup && data.propertyGroup.propertyList.length > 0 ) { %>
		<% for ( var item of data.propertyGroup.propertyList ) { %>
			<div class="model-size-guide-title">
				<p class="p1"><%= item.propertyName %></p>
			</div>
			<% if ( item.propertyOptionList ) { %>
				<div class="model-size-guide-step-bar <% if ( item.propertyOptionList.length == 3 ) { %>model-size-guide-step-bar-two<% } %>">
					<div class="size-guide-step-bar-line" style="width:<%= 100-100/item.propertyOptionList.length %>%;left:<%= 100/item.propertyOptionList.length/2 %>%;"></div>
					<div class="size-guide-step-bar-box">
						<% for ( var item2 of item.propertyOptionList ) { %>
							<div class="step-bar-boxcon <% if (item2.propertyOptionId == item.choosePropertyOptionIdList[0]) { %> step-bar-boxcon-active <% } %>" style="width:<%= 100/item.propertyOptionList.length %>%;">
								<div class="step-bar-boxcon-dot"></div>
								<div class="step-bar-boxcon-text"><%= item2.propertyOption %></div>
							</div>
						<% } %>
					</div>
				</div>
			<% } %>
		<% } %>
	<% } %>
	<!-- 判断当bodysize有数据时，展示tab切换，没有数据时，只展示productsize -->
	<% if ( data.bodySizeList && data.bodySizeList[0].headerList && data.bodySizeList[0].headerList.length > 0 ) { %>
		<!-- Measurements模块区域 -->
		<div class="model-size-guide-title">
			<p class="p1">Measurements</p>
		</div>
		<div class="model-size-guide-measurements-box">
			<div class="model-size-guide-measurements">
				<ul class="h-measurements-tabbox">
					<li class="active">Body Size</li>
					<li>Product Size</li>
				</ul>
			</div>
			<ul class="h-measurements-tabbox-content">
				<li class="h-measurements-tabbox-li h-measurements-tabbox-bodysize tabbox-current"></li>
				<li class="h-measurements-tabbox-li h-measurements-tabbox-productsize"></li>
			</ul>
		</div>
	<% } else { %>
		<div class="h-one-size-productsize"></div>
	<% } %>
`;

// 详情页size guide错误提示弹窗
var sizeGuideContentError = `
	<!-- 错误提示区域 -->
	<div class="main-popup-con-error-prompt">
		<img class="error_img" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/looksky_error.png?v=1646038962" />
		<p class="p-tips">Something seems to be missing here, try refreshing the page!</p>
		<div class="h-prompt-refresh-btn" value="<%= data.productId %>">refresh the page</div>
	</div>
`;

// 定义sizeGuide的bodysize和productsize的公共内容区域
var sizeGuidePublicContent = `
	<!-- Product size区域 -->
	<div class="model-size-guide-product-size">
		<% if ( data.tableListData && data.tableListData.length > 0 ) { %>
			<% for ( var tmpObj of data.tableListData ) { %>
				<div class="model-size-guide-product-size-box">
					<% if ( tmpObj.headerList.length > 0 ) { %>
						<div class="model-size-guide-title">
							<!-- 判断当只展示productsize的情况下，显示该标题 -->
							<% if ( data.bodySizeList && data.bodySizeList[0].headerList && data.bodySizeList[0].headerList.length > 0 ) { %>
								<p class="p1"></p>
							<% } else { %>
								<p class="p1"><%= tmpObj.title %></p>
							<% } %>
							<div class="title-right">
								<ul class="size-right-tab">
									<li class="active"><div class="li-radio"></div>IN</li>
									<li><div class="li-radio"></div>CM</li>
								</ul>
							</div>
						</div>
					<% } %>
					<div class="model-size-guide-table">
						<% if ( tmpObj.headerList.length > 0 ) { %>
							<div class="model-size-guide-table-box">
								<div class="size-guide-tablebox">
									<ul class="size-ul-table">
										<!-- 第一个表格 -->
										<li class="tablebox tablebox-current <% if (tmpObj.headerList.length > 5) { %>tablebox-length<% } %>">
											<% if (tmpObj.headerList.length <= 5) { %>
												<div class="tablebox-thead">
													<% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
														<% if ( index != 1 ) { %>
                              <p style="width: <%= 100/(tmpObj.headerList.length-1) %>%;"><%= item %></p>
														<% } %>
													<% } %>
												</div>
												<div class="tablebox-tbody">
													<% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
														<div class="tablebox-tbody-tr">
															<% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
																<% if ( index2 != 1 ) { %>
																	<p style="width: <%= 100/(Object.keys(tmpObj.sizeTableRowList[0]).length-1) %>%;">
																		<% if ( index2 < 1 ) { %>
																			<%= item[tmpObj.headerList[index2]] %>
																		<% } else if ( index2 > 1 ) { %>
																			<% if ( item[tmpObj.headerList[index2]] && item[tmpObj.headerList[index2]].indexOf("-") == -1 ) { %>
																				<%= Math.round(item[tmpObj.headerList[index2]]*0.3937*10)/10 %>
																			<% } else { %>
																				<% if ( item[tmpObj.headerList[index2]] ) { %>
																					<% for ( let [ index3, item3 ] of new Map( item[tmpObj.headerList[index2]].split("-").map( ( item, index ) => [ index, item ] ) ) ) { %>
																						<%= Math.round(item3*0.3937*10)/10 %><% if ( index3+1 < item[tmpObj.headerList[index2]].split("-").length ) { %> -<% } %>
																					<% } %>
																				<% } %>
																			<% } %>
																		<% } %>
																	</p>
																<% } %>
															<% } %>
														</div>
													<% } %>
												</div>
											<% } else { %>
												<!-- 左边区域 -->
												<div class="tablebox-length-left">
													<div class="tablebox-thead">
														<% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
															<% if ( index < 1 ) { %>
																<p><%= item %></p>
															<% } %>
														<% } %>
													</div>
													<div class="tablebox-tbody">
														<% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
															<div class="tablebox-tbody-tr">
																<% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
																	<% if ( index2 < 1 ) { %>
																		<p><%= item[tmpObj.headerList[index2]] %></p>
																	<% } %>
																<% } %>
															</div>
														<% } %>
													</div>
												</div>
												<!-- 右边区域 -->
												<div class="tablebox-length-right">
													<div class="tablebox-length-right-box">
														<div class="tablebox-thead">
															<% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
																<% if ( index > 1 ) { %>
																	<p><%= item %></p>
																<% } %>
															<% } %>
														</div>
														<div class="tablebox-tbody">
															<% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
																<div class="tablebox-tbody-tr">
																	<% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
																		<% if ( index2 > 1 ) { %>
																			<p>
																				<% if ( item[tmpObj.headerList[index2]] && item[tmpObj.headerList[index2]].indexOf("-") == -1 ) { %>
																					<%= Math.round(item[tmpObj.headerList[index2]]*0.3937*10)/10 %>
																				<% } else { %>
																					<% if ( item[tmpObj.headerList[index2]] ) { %>
																						<% for ( let [ index3, item3 ] of new Map( item[tmpObj.headerList[index2]].split("-").map( ( item, index ) => [ index, item ] ) ) ) { %>
																							<%= Math.round(item3*0.3937*10)/10 %><% if ( index3+1 < item[tmpObj.headerList[index2]].split("-").length ) { %> -<% } %>
																						<% } %>
																					<% } %>
																				<% } %>
																			</p>
																		<% } %>
																	<% } %>
																</div>
															<% } %>
														</div>
													</div>
												</div>
											<% } %>
										</li>
										<!-- 第二个表格 -->
										<li class="tablebox <% if (tmpObj.headerList.length > 5) { %>tablebox-length<% } %>">
											<% if (tmpObj.headerList.length <= 5) { %>
												<div class="tablebox-thead">
													<% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
														<% if ( index != 1 ) { %>
                              <p style="width: <%= 100/(tmpObj.headerList.length-1) %>%;"><%= item %></p>
														<% } %>
													<% } %>
												</div>
												<div class="tablebox-tbody">
													<% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
														<div class="tablebox-tbody-tr">
															<% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
																<% if ( index2 != 1 ) { %>
																	<p style="width: <%= 100/(Object.keys(tmpObj.sizeTableRowList[0]).length-1) %>%;"><%= item[tmpObj.headerList[index2]] %></p>
																<% } %>
															<% } %>
														</div>
													<% } %>
												</div>
											<% } else { %>
												<!-- 左边区域 -->
												<div class="tablebox-length-left">
													<div class="tablebox-thead">
														<% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
															<% if ( index < 1 ) { %>
																<p><%= item %></p>
															<% } %>
														<% } %>
													</div>
													<div class="tablebox-tbody">
														<% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
															<div class="tablebox-tbody-tr">
																<% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
																	<% if ( index2 < 1 ) { %>
																		<p><%= item[tmpObj.headerList[index2]] %></p>
																	<% } %>
																<% } %>
															</div>
														<% } %>
													</div>
												</div>
												<!-- 右边区域 -->
												<div class="tablebox-length-right">
													<div class="tablebox-length-right-box">
														<div class="tablebox-thead">
															<% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
																<% if ( index > 1 ) { %>
																	<p><%= item %></p>
																<% } %>
															<% } %>
														</div>
														<div class="tablebox-tbody">
															<% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
																<div class="tablebox-tbody-tr">
																	<% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
																		<% if ( index2 > 1 ) { %>
																			<p><%= item[tmpObj.headerList[index2]] %></p>
																		<% } %>
																	<% } %>
																</div>
															<% } %>
														</div>
													</div>
												</div>
											<% } %>
										</li>
									</ul>
								</div>
							</div>
						<% } %>
					</div>
				</div>
			<% } %>
		<% } %>
		<!-- 模特区域 -->
		<% if ( data.mannequin && JSON.stringify(data.mannequin) != "{}" ) { %>
			<div class="model-size-guide-table-user">
				<div class="table-user-left">
					<img src="<%= data.mannequin.headImage %>" />
				</div>
				<div class="table-user-right">
					<div class="table-user-right-li">
						<p class="p1">Name</p>
						<p class="p2"><%= data.mannequin.modelName ? data.mannequin.modelName : 'None' %></p>
					</div>
					<div class="table-user-right-li">
						<p class="p1">Model Size </p>
						<p class="p2"><%= data.mannequin.modelSize ? data.mannequin.modelSize.substr(0, data.mannequin.modelSize.indexOf("（")) : 'None' %></p>
					</div>
					<div class="table-user-right-li">
						<p class="p1">Height</p>
						<p class="p2"><%= data.mannequin.height ? data.mannequin.height : 'None' %></p>
					</div>
					<div class="table-user-right-li">
						<p class="p1">Bust</p>
						<p class="p2"><%= data.mannequin.bust ? data.mannequin.bust : 'None' %></p>
					</div>
					<div class="table-user-right-li">
						<p class="p1">Waist</p>
						<p class="p2"><%= data.mannequin.waist ? data.mannequin.waist : 'None' %></p>
					</div>
					<div class="table-user-right-li">
						<p class="p1">Hips</p>
						<p class="p2"><%= data.mannequin.hips ? data.mannequin.hips : 'None' %></p>
					</div>
				</div>
			</div>
		<% } %>
	</div>
	<!-- 商品品类介绍区域 -->
	<% for ( var item of data.productCategory ) { %>
		<% if (item.type == data.measureTemplateType) { %>
			<div class="model-size-guide-title">
				<p class="p1">How to measure the product’s size?</p>
			</div>
			<div class="model-size-guide-clothes-type">
				<div class="clothes-type-imgbox">
					<% for ( var item2 of item.imgList ) { %>
						<img src="<%= item2 %>" />
					<% } %>
				</div>
				<div class="clothes-type-listbox">
					<% for ( var item2 of item.categoryList ) { %>
						<div class="clothes-type-listbox-li">
							<p class="p1"><%= item2.label %></p>
							<p class="p2"><%= item2.value %></p>
						</div>
					<% } %>
				</div>
			</div>
		<% } %>
	<% } %>
	<!-- 底部提示区域 -->
	<div class="model-size-guide-email-tip">
		<p class="p1">Any questions about choosing a size, please contact us at <a href="mailto:service@graecove.com">service@graecove.com</a></p>
	</div>
`;

// 定义商品品类介绍数据
var productCategory = [
	{
		title: 'Pants Sets/Shorts Sets',
		type: 1,
		imgList: [
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/Pants_Sets_Shorts_Sets1.png?v=1645083469',
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/ic_bottom_length.png?v=1647436324'
		],
		categoryList: [
			{
				label: '· Shoulder',
				value: 'Start at the top of the shoulder, where the shoulder and sleeve meet. Then, measure across the upper back to the opposite shoulder. '
			},
			{
				label: '· Bust',
				value: 'Start at the chest (at the bottom of the armhole). Measure straight across the front of the garment to the opposite point. '
			},
			{
				label: '· Sleeve',
				value: 'Start the top of the sleeve (where the shoulder and sleeve meet) then measure down the top of the sleeve towards the cuff edge. '
			},
			{
				label: '· Top Length',
				value: 'Start at the top of the garment (near the collar/shoulder area). Then measure down to the hem of the garment.'
			},
			{
				label: '· Waist',
				value: 'Start at the top of the waistband and measure straight across to the opposite side.  '
			},
			{
				label: '· Hip',
				value: 'Start the widest point of the garment (at the hip) and measure straight across to the opposite side. '
			},
			{
				label: '· Bottom Length',
				value: 'Measure from waistband side seam to bottom of hem.'
			}
		]
	},
	{
		title: 'Blazers',
		type: 2,
		imgList: [
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/Blazers1.png?v=1645173446'
		],
		categoryList: [
			{
				label: '· Shoulder',
				value: 'Start at the top of the shoulder, where the shoulder and sleeve meet. Then, measure across the upper back to the opposite shoulder. '
			},
			{
				label: '· Bust',
				value: 'Start at the chest (at the bottom of the armhole). Measure straight across the front of the garment to the opposite point. '
			},
			{
				label: '· Top Length',
				value: 'Start at the top of the garment (near the collar/shoulder area). Then measure down to the hem of the garment.'
			},
			{
				label: '· Sleeve',
				value: 'Start the top of the sleeve (where the shoulder and sleeve meet) then measure down the top of the sleeve towards the cuff edge. '
			}
		]
	},
	{
		title: 'Blouse/Shirts',
		type: 3,
		imgList: [
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/Blouse_Shirts1.png?v=1645173446'
		],
		categoryList: [
			{
				label: '· Shoulder',
				value: 'Start at the top of the shoulder, where the shoulder and sleeve meet. Then, measure across the upper back to the opposite shoulder. '
			},
			{
				label: '· Bust',
				value: 'Start at the chest (at the bottom of the armhole). Measure straight across the front of the garment to the opposite point. '
			},
			{
				label: '· Top Length',
				value: 'Start at the top of the garment (near the collar/shoulder area). Then measure down to the hem of the garment.'
			},
			{
				label: '· Sleeve',
				value: 'Start the top of the sleeve (where the shoulder and sleeve meet) then measure down the top of the sleeve towards the cuff edge. '
			}
		]
	},
	{
		title: 'Dresses',
		type: 4,
		imgList: [
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/ic_dresses1.png?v=1647436673'
		],
		categoryList: [
			{
				label: '· Shoulder',
				value: 'Start at the top of the shoulder, where the shoulder and sleeve meet. Then, measure across the upper back to the opposite shoulder. '
			},
			{
				label: '· Bust',
				value: 'Start at the chest (at the bottom of the armhole). Measure straight across the front of the garment to the opposite point. '
			},
			{
				label: '· Sleeve',
				value: 'Start the top of the sleeve (where the shoulder and sleeve meet) then measure down the top of the sleeve towards the cuff edge. '
			},
			{
				label: '· Waist',
				value: 'Start at the top of the waistband and measure straight across to the opposite side. '
			},
			{
				label: '· Hip',
				value: 'Start the widest point of the garment (at the hip) and measure straight across to the opposite side. '
			},
			{
				label: '· Length',
				value: 'Measure from where the shoulder seam meets the collar to the hem. For suspender styles, measure from the chest point of the shoulder straps to the hem. '
			}
		]
	},
	{
		title: 'Knitwears',
		type: 5,
		imgList: [
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/Knitwears1.png?v=1645410400'
		],
		categoryList: [
			{
				label: '· Shoulder',
				value: 'Start at the top of the shoulder, where the shoulder and sleeve meet. Then, measure across the upper back to the opposite shoulder. '
			},
			{
				label: '· Bust',
				value: 'Start at the chest (at the bottom of the armhole). Measure straight across the front of the garment to the opposite point. '
			},
			{
				label: '· Top Length',
				value: 'Start at the top of the garment (near the collar/shoulder area). Then measure down to the hem of the garment.'
			},
			{
				label: '· Sleeve',
				value: 'Start the top of the sleeve (where the shoulder and sleeve meet) then measure down the top of the sleeve towards the cuff edge. '
			}
		]
	},
	{
		title: 'Pants/Shorts/Leggings',
		type: 6,
		imgList: [
			'https://cdn.shopifycdn.net/s/files/1/0594/1162/8204/files/ic_pant_bottom.png?v=1647507508'
		],
		categoryList: [
			{
				label: '· Waist',
				value: 'Start at the top of the waistband and measure straight across to the opposite side. '
			},
			{
				label: '· Hip',
				value: 'Start the widest point of the garment (at the hip) and measure straight across to the opposite side.  '
			},
			{
				label: '· Length',
				value: 'Measure from waistband side seam to bottom of hem.'
			}
		]
	},
	{
		title: 'Skirts',
		type: 7,
		imgList: [
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/ic_skirts1.png?v=1647436960'
		],
		categoryList: [
			{
				label: '· Waist',
				value: 'Start at the top of the waistband and measure straight across to the opposite side. '
			},
			{
				label: '· Hip',
				value: 'Start the widest point of the garment (at the hip) and measure straight across to the opposite side.  '
			},
			{
				label: '· Length',
				value: 'Measure from waistband side seam to leg opening or hem.'
			}
		]
	},
	{
		title: 'Skirts Sets',
		type: 8,
		imgList: [
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/Skirts_Sets1.png?v=1645173446',
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/ic_skirts_bottom1.png?v=1647437356'
		],
		categoryList: [
			{
				label: '· Shoulder',
				value: 'Start at the top of the shoulder, where the shoulder and sleeve meet. Then, measure across the upper back to the opposite shoulder. '
			},
			{
				label: '· Bust',
				value: 'Start at the chest (at the bottom of the armhole). Measure straight across the front of the garment to the opposite point. '
			},
			{
				label: '· Sleeve',
				value: 'Start the top of the sleeve (where the shoulder and sleeve meet) then measure down the top of the sleeve towards the cuff edge. '
			},
			{
				label: '· Top Length',
				value: 'Start at the top of the garment (near the collar/shoulder area). Then measure down to the hem of the garment.'
			},
			{
				label: '· Waist',
				value: 'Start at the top of the waistband and measure straight across to the opposite side.  '
			},
			{
				label: '· Hip',
				value: 'Start the widest point of the garment (at the hip) and measure straight across to the opposite side. '
			},
			{
				label: '· Bottom Length',
				value: 'Measure from waistband side seam to leg opening or hem.'
			}
		]
	},
	{
		title: 'Sweatshirts/Hoodies/Jackets/Coats',
		type: 9,
		imgList: [
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/Sweatshirts_Hoodies_Jackets_Coats1.png?v=1645173446'
		],
		categoryList: [
			{
				label: '· Shoulder',
				value: 'Start at the top of the shoulder, where the shoulder and sleeve meet. Then, measure across the upper back to the opposite shoulder. '
			},
			{
				label: '· Bust',
				value: 'Start at the chest (at the bottom of the armhole). Measure straight across the front of the garment to the opposite point. '
			},
			{
				label: '· Top Length',
				value: 'Start at the top of the garment (near the collar/shoulder area). Then measure down to the hem of the garment.'
			},
			{
				label: '· Sleeve',
				value: 'Start the top of the sleeve (where the shoulder and sleeve meet) then measure down the top of the sleeve towards the cuff edge. '
			}
		]
	},
	{
		title: 'T-Shirts/Crop Tops',
		type: 10,
		imgList: [
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/T-Shirts_Crop_Tops1.png?v=1645173446'
		],
		categoryList: [
			{
				label: '· Shoulder',
				value: 'Start at the top of the shoulder, where the shoulder and sleeve meet. Then, measure across the upper back to the opposite shoulder. '
			},
			{
				label: '· Bust',
				value: 'Start at the chest (at the bottom of the armhole). Measure straight across the front of the garment to the opposite point. '
			},
			{
				label: '· Length',
				value: 'Start at the top of the garment (near the collar/shoulder area). Then measure down to the hem of the garment.'
			},
			{
				label: '· Sleeve',
				value: 'Start the top of the sleeve (where the shoulder and sleeve meet) then measure down the top of the sleeve towards the cuff edge. '
			}
		]
	},
	{
		title: 'Tank Tops/Halter Tops/Camis/Corsets',
		type: 11,
		imgList: [
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/ic_tank_tops1.png?v=1647437559'
		],
		categoryList: [
			{
				label: '· Bust',
				value: 'Start at the chest (at the bottom of the armhole). Measure straight across the front of the garment to the opposite point. '
			},
			{
				label: '· Length',
				value: 'Measure from where the shoulder seam meets the collar to the hem. For suspender styles, measure from the chest point of the shoulder straps to the hem.'
			}
		]
	},
	{
		title: 'Vest',
		type: 12,
		imgList: [
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/Vest1.png?v=1645173447'
		],
		categoryList: [
			{
				label: '· Shoulder',
				value: 'Start at the top of the shoulder, where the shoulder and sleeve meet. Then, measure across the upper back to the opposite shoulder. '
			},
			{
				label: '· Bust',
				value: 'Start at the chest (at the bottom of the armhole). Measure straight across the front of the garment to the opposite point. '
			},
			{
				label: '· Top Length',
				value: 'Start at the top of the garment (near the collar/shoulder area). Then measure down to the hem of the garment.'
			}
		]
	},
	{
		title: 'Bodysuit',
		type: 13,
		imgList: [
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/ic_bodysuit1.png?v=1647435934'
		],
		categoryList: [
			{
				label: '· Bust',
				value: 'Start at the chest (at the bottom of the armhole). Measure straight across the front of the garment to the opposite point. '
			},
			{
				label: '· Length',
				value: 'Measure from where the shoulder seam meets the collar to the bottom of the crotch.'
			}
		]
	},
	{
		title: 'Jumpsuits',
		type: 14,
		imgList: [
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/ic_jumpsuits.png?v=1647435934'
		],
		categoryList: [
			{
				label: '· Shoulder',
				value: 'Start at the top of the shoulder, where the shoulder and sleeve meet. Then, measure across the upper back to the opposite shoulder. '
			},
			{
				label: '· Bust',
				value: 'Start at the chest (at the bottom of the armhole). Measure straight across the front of the garment to the opposite point. '
			},
			{
				label: '· Hip',
				value: 'Start the widest point of the garment (at the hip) and measure straight across to the opposite side. '
			},
			{
				label: '· Length',
				value: 'Measure from where the shoulder seam meets the collar to the hem.'
			}
		]
	},
	{
		title: 'bodysize_img',
		type: 100,
		imgList: [
			'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/bodysize_1.png?v=1647916707'
		],
		categoryList: [
			{
				label: '· Bust',
				value: 'With arms relaxed down at the sides,measure the fullest part of bust,keeping tape parallel to floor.'
			},
			{
				label: '· Waist',
				value: 'Measure around your natural waistline,which is the smallest area of the waist.'
			},
			{
				label: '· Hip',
				value: 'Stand with feet together.Keep tape straight and parallel to the floor.Measure around fullest part.'
			}
		]
	}
];

// 调用详情页接口
if(location.pathname.includes("/products/") || location.pathname.includes("/products_preview")){
	// 当获取到商品ID时
	if ($(".product-form").attr('data-product-id')) {
		// 调用获取商品size相关信息的方法，参数：商品ID，来源
		var getProductId = $(".product-form").attr('data-product-id');
		getQueryProductPropertyInfo(getProductId, '1');
	}
}
function getQueryProductPropertyInfo(productId, fromType, callback) {
	LS.ajax({
		url: '/global/rest/v1/api/shopify/product/queryProductPropertyInfo',
		type: "GET",
		data: {
			productId: productId,
		},
		success: function (response) {
			if (!response.hasError && response.code == '0') {
				// console.log('********1', response);
				// 获取接口数据
				var getProductPropertyInfo = response.data;
	
				// 当商品size guide没有size数据时，隐藏入口
				if ( getProductPropertyInfo.productDetailSizeTablePropertyList && getProductPropertyInfo.productDetailSizeTablePropertyList.length > 0 ) {
					$('.h-look-size-guide').text('SIZE GUIDE');
				}
	
				// 生成html片段代码
				try{
					var getProductSizeTabletHtmlStr = LS.tmpl(getProductSizeTableModel, getProductPropertyInfo);
				}catch(error) {
					console.error('Error:', error);
				}
				// 添加到详情页页面
				if ( getProductSizeTabletHtmlStr ) {
					if ( fromType == '1' ) {
						// 当为详情页初次进入加载时
						$(".h-size-describe-commodity-data").html(getProductSizeTabletHtmlStr);
					} else if ( fromType == '2' ) {
						// 当为theme.js里在web端查看商品弹窗时
						callback(getProductSizeTabletHtmlStr);
					} else if ( fromType == '3' ) {
						// 当为phone端查看商品弹窗时
						callback(getProductSizeTabletHtmlStr);
					}
					// 当one-size时，默认展示size详情区域
					if ( getProductPropertyInfo.bodySizeList && getProductPropertyInfo.bodySizeList.length == 0 && getProductPropertyInfo.productDetailSizeTablePropertyList && getProductPropertyInfo.productDetailSizeTablePropertyList.length > 0 ) {
						$(".h-size-describe-commodity-data").children(".h-size-describe-commodity-data-con[value='One-size']").show()
					}
				}
	
				// 当来源类型为详情页时
				if ( fromType == '1' ) {
					// 生成html片段代码
					try{
						var getProductHtmlStr = LS.tmpl(getProductContentModel, getProductPropertyInfo);
					}catch(error) {
						console.error('Error:', error);
						window.imgReport({ page_url: window.location.href, eid: "js_error", ext1: error+'', ext2: 'looksky-main-popup', ext3: '961'});
					}
					// 添加到详情页页面
					$(".h-product-details-description-module").html(getProductHtmlStr);
	
					// 调用点击product Detail以及material Care打开弹窗方法
					clickMenuPopupHandle(getProductPropertyInfo);
				}
	
			}
		},
		error: function (error) {
			if (error) {
				// console.log('*******3');
				window.imgReport({ page_url: window.location.href, eid: "js_error", ext1: error+'', ext2: 'looksky-main-popup', ext3: '974'});
			}
		},
	});
}

// product Detail以及material Care打开弹窗方法
function clickMenuPopupHandle(getProductData) {
	
	// 点击Product Details
	$(document).on('click','.h-description-productsize-click',function(){
		// console.log('点击Product Details------');

		// 详情页点击product_details上报
		detail_click_product_details();

		// 判断是否已经存在弹窗，如果没有存在，创建弹窗内容，如果存在，则直接显示内容
		if ($('.looksky-main-popup-productsize').html()) {
			// 存在弹窗内容
			// console.log('存在弹窗内容');
			// 显示已有弹窗
			$('.looksky-main-popup-productsize').show();
			// 详情页打开product detail弹窗上报
			detail_open_product_details();
		} else {
			// 不存在弹窗内容
			// console.log('不存在弹窗内容');
			// 创建弹窗
			createProductSizePopup();
		}

		// 关闭弹窗
		$(document).on('click','.looksky-main-popup-productsize .title-close',function(){
			$(this).parents('.looksky-main-popup-productsize').hide();
		})
		$(document).on('click','.looksky-main-popup-productsize',function(){
			$(this).hide();
		})
		$(document).on('click','.looksky-main-popup-productsize .looksky-main-popup-con',function(e){
			e.stopPropagation();
		})

		// 创建弹窗方法
		function createProductSizePopup() {
			// 创建弹窗
			var main_popup = document.createElement('div');
			main_popup.className = 'looksky-main-popup looksky-main-popup-productsize';
			// console.log('******2', main_popup);
			document.body.appendChild(main_popup);

			// 生成html片段代码
			try{
				var htmlStr = LS.tmpl(productSizeContent, getProductData);
			}catch(error) {
				console.error('Error:', error);
				window.imgReport({ page_url: window.location.href, eid: "js_error", ext1: error+'', ext2: 'looksky-main-popup', ext3: '1022'});
			}
			// console.log('******1', htmlStr);
			// 添加到弹窗页面
			$(".looksky-main-popup-productsize").html(htmlStr);
			// 详情页打开product detail弹窗上报
			detail_open_product_details();
			// console.log('#######', $(".looksky-main-popup-productsize").html());
		}

	});

	// 点击Material & Care
	$(document).on('click','.h-description-materialcare-click',function(){
		// console.log('点击Material & Care------');

		// 详情页点击material&care上报
		detail_click_material_care();

		// 判断是否已经存在弹窗，如果没有存在，创建弹窗内容，如果存在，则直接显示内容
		if ($('.looksky-main-popup-materialcare').html()) {
			// 存在弹窗内容
			// console.log('存在弹窗内容');
			// 显示已有弹窗
			$('.looksky-main-popup-materialcare').show();
			// 详情页打开material&care弹窗上报
			detail_open_material_care();
		} else {
			// 不存在弹窗内容
			// console.log('不存在弹窗内容');
			// 创建弹窗
			createMaterialCarePopup();
		}

		// 关闭弹窗
		$(document).on('click','.looksky-main-popup-materialcare .title-close',function(){
			$(this).parents('.looksky-main-popup-materialcare').hide();
		})
		$(document).on('click','.looksky-main-popup-materialcare',function(){
			$(this).hide();
		})
		$(document).on('click','.looksky-main-popup-materialcare .looksky-main-popup-con',function(e){
			e.stopPropagation();
		})

		// 创建弹窗方法
		function createMaterialCarePopup() {
			// 创建弹窗
			var main_popup = document.createElement('div');
			main_popup.className = 'looksky-main-popup looksky-main-popup-materialcare';
			// console.log('******2', main_popup);
			document.body.appendChild(main_popup);

			// 定义Care数据
			var careList = [
				{ imgurl: 'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon_care1.png?v=1645067028', text: 'Machine wash max. 30°C/86°F delicate cycle' },
				{ imgurl: 'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon_care2.png?v=1645067027', text: 'Do not use bleach / whitener' },
				{ imgurl: 'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon_care3.png?v=1645067028', text: 'Iron maximum 110°C/230°F' },
				{ imgurl: 'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon_care4.png?v=1645067028', text: 'Iron maximum 110°C/230°F' },
				{ imgurl: 'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/icon_care5.png?v=1645067027', text: 'Do not tumble dry' },
			];
			// 把自定义的care数据加入接口数据里
			getProductData.careList = careList;
			
			// 生成html片段代码
			try{
				var htmlStr = LS.tmpl(materialCareContent, getProductData);
			}catch(error) {
				console.error('Error:', error);
				window.imgReport({ page_url: window.location.href, eid: "js_error", ext1: error+'', ext2: 'looksky-main-popup', ext3: '1085'});
			}
			// console.log('******1', htmlStr);
			// 添加到弹窗页面
			$(".looksky-main-popup-materialcare").html(htmlStr);
			// 详情页打开material&care弹窗上报
			detail_open_material_care();
			// console.log('#######', $(".looksky-main-popup-materialcare").html());
		}

	});

}

// 点击SIZE GUIDE
$(document).on('click','.h-look-size-guide',function(){

	// 获取商品ID
	var getProductId = $(this).parents(".product-form").attr('data-product-id')

	// console.log('点击SIZE GUIDE------');
	// 详情页点击size_guide弹窗上报
	detail_click_size_guide();

	// 判断是否已经存在弹窗，如果没有存在，创建弹窗内容，如果存在，则直接显示内容
	if ($('.looksky-main-popup-sizeguide').html() && $('.looksky-main-popup-sizeguide').attr('productId') == getProductId) {
		// 存在弹窗内容
		// console.log('存在弹窗内容');
		// 显示已有弹窗
		$('.looksky-main-popup-sizeguide').show()
		// 详情页打开size_guide弹窗上报
		detail_open_size_guide();
	} else {
		// 不存在弹窗内容
		// console.log('不存在弹窗内容');
		// 删除之前创建的弹窗
		$(".looksky-main-popup-sizeguide").remove();
		// 创建初始弹窗
		var main_popup = document.createElement('div');
		main_popup.className = 'looksky-main-popup looksky-main-popup-sizeguide';
		main_popup.setAttribute('productId', getProductId);
		// console.log('******sizeguide', main_popup);
		document.body.appendChild(main_popup);
		// var htmlBox = LS.tmpl(sizeGuideContent, {});
		// 添加到弹窗页面
		$(".looksky-main-popup-sizeguide").html(sizeGuideContent);
		// 通过接口创建sizeguide弹窗的方法
		createSizeGuidePopupHandle(getProductId);
	}

	// 通过接口创建sizeguide弹窗的方法
	function createSizeGuidePopupHandle(getProductId) {
		// 调用接口
		LS.ajax({
			url: '/global/rest/v1/api/shopify/product/queryProductSizeGuideInfo',
			type: "GET",
			data: {
				productId: getProductId,
			},
			success: function (response) {
				if (!response.hasError && response.code == '0') {
					// console.log('********1', response);
					// 判断有无size维度
					if (!response.data.sizeTables || response.data.sizeTables.length == 0) {
						// 显示提示弹窗
						$(".main-toast-tip-popup").text(LS.$t('public.add_pop.lack_size_guide', '', 1)).show();
						setTimeout(()=> {
							$(".main-toast-tip-popup").hide();
						}, 2000)
					} else {
						// 创建弹窗
						createSizeGuidePopup(response.data, '1', getProductId);
						// 详情页打开size_guide弹窗上报
						detail_open_size_guide();
					}
				} else {
					// 创建弹窗
					var customData = {
						'propertyGroupName': 'SIZE GUIDE',
						'productId': getProductId
					}
					createSizeGuidePopup(customData, '2', getProductId);
				}
			},
			error: function (error) {
				if (error) {
					// console.log('*******3');
					window.imgReport({ page_url: window.location.href, eid: "js_error", ext1: error+'', ext2: 'looksky-main-popup', ext3: '1143'});
				}
			},
		});
	}

	// 创建弹窗方法
	function createSizeGuidePopup(productSizeGuideData, setType, getProductId) {
		
		// 生成html片段代码
		try{

			// 把自定义的商品品类介绍数据加入接口数据里
			productSizeGuideData.productCategory = productCategory;

			// 生成
			if ( setType == '1' ) {
				var htmlStr = LS.tmpl(sizeGuideContentData, productSizeGuideData);
			} else {
				var htmlStr = LS.tmpl(sizeGuideContentError, productSizeGuideData);
			}
		}catch(error) {
			console.error('Error:', error);
			window.imgReport({ page_url: window.location.href, eid: "js_error", ext1: error+'', ext2: 'looksky-main-popup', ext3: '1171'});
		}

		// 添加到弹窗页面
		$(".looksky-main-popup-sizeguide .con-model-size-guide").html(htmlStr);

		// 生成sizeguide的公用内容模块

		// bodysize数据
		var bodySizeDataInfo = JSON.parse(JSON.stringify(productSizeGuideData));
		bodySizeDataInfo.tableListData = productSizeGuideData.bodySizeList;
		bodySizeDataInfo.measureTemplateType = 100;
		var htmlBodySizeStr = LS.tmpl(sizeGuidePublicContent, bodySizeDataInfo);

		// productsize数据
		var productSizeDataInfo = JSON.parse(JSON.stringify(productSizeGuideData));
		productSizeDataInfo.tableListData = productSizeGuideData.sizeTables;
		var htmlProductSizeStr = LS.tmpl(sizeGuidePublicContent, productSizeDataInfo);

		// 添加bodysize,productsize公共区域
		$(".h-measurements-tabbox-bodysize").html(htmlBodySizeStr);
		$(".h-measurements-tabbox-productsize").html(htmlProductSizeStr);
		$(".h-one-size-productsize").html(htmlProductSizeStr);
	}

	// 关闭弹窗
	$(document).on('click','.looksky-main-popup-sizeguide .title-close',function(){
		$(this).parents('.looksky-main-popup-sizeguide').hide();
	})
	$(document).on('click','.looksky-main-popup-sizeguide',function(){
		$(this).hide();
	})
	$(document).on('click','.looksky-main-popup-sizeguide .looksky-main-popup-con',function(e){
		e.stopPropagation();
	})

	// 点击刷新sizeguide弹窗重新获取数据
	$(document).on('click','.looksky-main-popup-sizeguide .h-prompt-refresh-btn',function(){
		// 删除原来的弹窗
		$(".looksky-main-popup-sizeguide").remove();
		// 通过接口创建sizeguide弹窗的方法
		// 创建初始弹窗
		var main_popup = document.createElement('div');
		main_popup.className = 'looksky-main-popup looksky-main-popup-sizeguide';
		main_popup.setAttribute('productId', $(this).attr("value"));
		// console.log('******sizeguide', main_popup);
		document.body.appendChild(main_popup);
		var htmlBox = LS.tmpl(sizeGuideContent, {});
		// 添加到弹窗页面
		$(".looksky-main-popup-sizeguide").html(htmlBox);
		createSizeGuidePopupHandle($(this).attr("value"));
	})

});